import type { AdminAbility } from '@repo/sdk/backoffice-abilities'
import type { QueryClient } from '@tanstack/react-query'
import { redirect } from '@tanstack/react-router'
import {
	hasAdminAbility,
	type PermissionCheckOptions
} from '@/modules/permissions/lib/has-admin-ability'
import { PermissionError } from '@/modules/permissions/lib/permission-error'
import { adminSessionQueryOptions } from '@/query/query-options'

export function requireAdminPermission(
	abilities: AdminAbility[],
	options?: PermissionCheckOptions
) {
	return async (routeContext: { context: { queryClient: QueryClient } }) => {
		// The parent (private) guard has already fetched the session; this only reads the cache.
		const data = await routeContext.context.queryClient.ensureQueryData(
			adminSessionQueryOptions()
		)
		const granted =
			data.sessionType === 'authenticated' ? data.abilities : null

		if (!hasAdminAbility(granted, abilities, options)) {
			// A facility manager has its own pages: send it to its residences
			// instead of a dead end on a page of the general admin.
			if (
				data.sessionType === 'authenticated' &&
				data.admin.role === 'facility_manager'
			) {
				throw redirect({ to: '/strutture' })
			}
			throw new PermissionError()
		}
	}
}
